import { Button } from "@chakra-ui/react";
import CollapseToggleButton, {
  CollapseToggleChevronIcon,
} from "components/Shared/CollapseToggleButton";

type Props = {
  isCompleted: boolean;
  isExpanded: boolean;
  onOpen: () => void;
  setIsExpanded: (isExpanded: boolean) => void;
};

export default function WidgetHeaderAction({
  isCompleted,
  isExpanded,
  onOpen,
  setIsExpanded,
}: Props) {
  if (isCompleted) {
    return (
      <CollapseToggleButton
        aria-label="Toggle setup resources"
        variant="unstyled"
        position="absolute"
        inset={0}
        width="100%"
        height="100%"
        display="flex"
        alignItems="flex-start"
        justifyContent="flex-end"
        color="gray.500"
        p={4}
        isExpanded={isExpanded}
        onExpandedChange={setIsExpanded}
        _focusVisible={{ boxShadow: "outline" }}
      >
        <CollapseToggleChevronIcon />
      </CollapseToggleButton>
    );
  }

  return (
    <Button
      aria-label="Open setup checklist"
      variant="unstyled"
      position="absolute"
      inset={0}
      width="100%"
      height="100%"
      onClick={onOpen}
      _focusVisible={{ boxShadow: "outline" }}
    />
  );
}
